import { isEmptyValue } from "../utils/is-empty-value";
import { GeneralFieldController } from "./general-field-controller";

export class ResponseReceivedFieldController extends GeneralFieldController {
	override mapInitialValue(value: unknown): unknown {
		return isEmptyValue(value) ? true : value;
	}
}
